import styled, { css } from 'styled-components'

const designerCSS = css`
  #gameplay {
    height: 65vh;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    position: relative;
    flex-direction: column;
    margin: 0;
  }

  #gameplay_stats {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
`

const developerCSS = css``

export const BustedPlayCSS = styled.div`
  width: 100%;
  height: 100%;
  /* display: grid;
  grid-template: 1fr auto / 1fr; */
  ${designerCSS}
  ${developerCSS}
`
